import React from 'react';
import type { ColDef, EditableCallbackParams } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import { getCreditSourceGroups, saveBatchCreditSourceGroups } from '../../api/creditSourceGroups';
import type { CreditSourceGroup } from '../../types/CreditSourceGroup';
import { t } from '../../i18n/t';

const columnDefs: ColDef<CreditSourceGroup>[] = [
  {
    field: 'creditSourceGroupId',
    headerName: t('creditSourceGroups.columns.creditSourceGroupId'),
    width: 120,
    cellDataType: 'number',
    editable: (params: EditableCallbackParams<CreditSourceGroup>) =>
      (params.data as { __status?: string } | undefined)?.__status === 'added',
    sort: 'asc',
  },
  { field: 'creditSourceGroupName', headerName: t('creditSourceGroups.columns.creditSourceGroupName'), flex: 1, editable: true },
  { field: 'creditSourceTypeId', headerName: t('creditSourceGroups.columns.creditSourceTypeId'), width: 160, cellDataType: 'number', editable: true },
];

const newRowDefaults = (): Partial<CreditSourceGroup> => ({ creditSourceGroupId: 0, creditSourceGroupName: '', creditSourceTypeId: 0 });

export function CreditSourceGroupsPage() {
  return (
    <LopCrudPage<CreditSourceGroup>
      resourceCode="creditSourceGroups"
      titleKey="creditSourceGroups.pageTitle"
      idField="creditSourceGroupId"
      getRows={getCreditSourceGroups}
      saveBatch={(added, modified, deletedIds) => saveBatchCreditSourceGroups(added, modified, deletedIds as number[])}
      columnDefs={columnDefs}
      newRowDefaults={newRowDefaults}
    />
  );
}
